import { driver } from "driver.js";
import "driver.js/dist/driver.css";

class TourService {
    constructor() {
        this.driverObj = null;
    }

    startTour(routeName, router = null) {
        this.router = router;
        const steps = this.getSteps(routeName);

        this.driverObj = driver({
            showProgress: true,
            animate: true,
            steps: steps,
            nextBtnText: 'Próximo',
            prevBtnText: 'Anterior',
            doneBtnText: 'Concluir',
            onDestroyed: () => {
                console.log('[Tour] Driver destroyed, cleaning up...');
                // Remove fake customer if tour is closed prematurely
                if (window.$customersPage) {
                    window.$customersPage.removeFakeCustomerForTour();
                }
                // Remove fake reschedule requests if tour is closed prematurely
                if (window.$rescheduleRequestsPage) {
                    window.$rescheduleRequestsPage.removeFakeRequestsForTour();
                    window.$rescheduleRequestsPage.currentTab = 0;
                }
                // Remove fake sessions if tour is closed prematurely
                if (window.$sessionsPage) {
                    window.$sessionsPage.removeFakeSessionsForTour();
                }
                // Remove fake vouchers if tour is closed prematurely
                if (window.$vouchersPage) {
                    window.$vouchersPage.removeFakeVouchersForTour();
                }
                // Remove fake taxes if tour is closed prematurely
                if (window.$taxesPage) {
                    window.$taxesPage.removeFakeTaxesForTour();
                }
                // Remove fake templates if tour is closed prematurely
                if (window.$contractTemplatesPage) {
                    window.$contractTemplatesPage.removeFakeTemplatesForTour();
                }
            },
        });

        this.driverObj.drive();
    }



    getSteps(routeName) {
        const fabStep = {
            element: '#tour-fab-main',
            popover: {
                title: 'Ações Rápidas',
                description: 'Clique aqui para adicionar rapidamente um novo cliente, agendamento ou registro financeiro.',
                side: "left",
                align: 'start'
            }
        };

        const steps = [];

        // Define route-specific tours
        switch (routeName) {
            case 'schedule':
                steps.push(
                    {
                        element: '#tour-calendar',
                        popover: {
                            title: 'Agenda',
                            description: 'Aqui você tem a visualização da sua agenda. Pode alterar entre Mês, Semana e Dia, e navegar pelos períodos usando os botões.',
                            side: "right",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-user-profile-btn',
                        popover: {
                            title: 'Configurações do Usuário',
                            description: 'Clique em "Próximo" para abrir suas configurações e ver como sincronizar com o Google Calendar.',
                            side: "right",
                            align: 'start',
                            onNextClick: () => {
                                console.log('[Tour] === Step 2 -> 3 Transition ===');
                                console.log('[Tour] window.$sideMenu exists:', !!window.$sideMenu);

                                // Access the global SideMenu instance and open the dialog
                                if (window.$sideMenu) {
                                    console.log('[Tour] Opening user dialog...');
                                    window.$sideMenu.openUserDialog();

                                    // Use Vue's $nextTick to ensure reactivity completes
                                    window.$sideMenu.$nextTick(() => {
                                        console.log('[Tour] Dialog opened, waiting for render...');

                                        // Wait for modal to fully render
                                        setTimeout(() => {
                                            // Poll for the element
                                            let attempts = 0;
                                            const maxAttempts = 20;
                                            const checkInterval = setInterval(() => {
                                                attempts++;
                                                const modalEl = document.querySelector('#tour-google-sync-section');

                                                if (modalEl) {
                                                    console.log('[Tour] Element found on attempt', attempts);
                                                    clearInterval(checkInterval);

                                                    // Move to next step FIRST
                                                    this.driverObj.moveNext();

                                                    // Then scroll AFTER driver has positioned the popover
                                                    setTimeout(() => {
                                                        console.log('[Tour] Now scrolling to element...');
                                                        modalEl.scrollIntoView({ behavior: 'smooth', block: 'center' });

                                                        // Force driver to refresh popover position after scroll
                                                        setTimeout(() => {
                                                            console.log('[Tour] Refreshing driver popover position...');
                                                            this.driverObj.refresh();
                                                        }, 500); // Wait for smooth scroll animation
                                                    }, 300);
                                                } else if (attempts >= maxAttempts) {
                                                    console.warn('[Tour] Element not found after', maxAttempts, 'attempts');
                                                    clearInterval(checkInterval);
                                                    this.driverObj.moveNext();
                                                }
                                            }, 150);
                                        }, 300);
                                    });
                                } else {
                                    console.error('[Tour] window.$sideMenu not found!');
                                    this.driverObj.moveNext();
                                }
                            }
                        }
                    },
                    {
                        element: '#tour-google-sync-section',
                        popover: {
                            title: 'Sincronização Google',
                            description: 'Conecte sua conta do Google e escolha o calendário para sincronizar seus atendimentos automaticamente.',
                            side: "top",
                            align: 'start',
                            onNextClick: () => {
                                console.log('[Tour] Step 3 -> 4: Closing user dialog');
                                // Close the modal before moving to next step
                                if (window.$sideMenu) {
                                    window.$sideMenu.show_dialog_edit_user = false;
                                }
                                // Move to next step
                                this.driverObj.moveNext();
                            }
                        }
                    },
                    {
                        element: '#tour-appointments-summary',
                        popover: {
                            title: 'Resumo de Atendimentos',
                            description: 'Aqui você tem um resumo dos atendimentos de acordo com o período exibido no calendário.',
                            side: "left",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-appointments-progress',
                        popover: {
                            title: 'Progresso',
                            description: 'Visualize graficamente seus atendimentos realizados, agendados e previstos.',
                            side: "left",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-reminders',
                        popover: {
                            title: 'Lembretes',
                            description: 'Fique de olho em aniversariantes, saldos baixos e pagamentos pendentes no período.',
                            side: "left",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-pending-records',
                        popover: {
                            title: 'Prontuários Pendentes',
                            description: 'Lista de atendimentos que ainda precisam ter o prontuário preenchido.',
                            side: "top",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-structuring',
                        popover: {
                            title: 'Atendimentos a estruturar',
                            description: 'Lista de atendimentos que ainda não foram estruturados.',
                            side: "top",
                            align: 'start'
                        }
                    },
                    fabStep
                );
                break;

            case 'dashboard':
                steps.push(
                    {
                        element: '#tour-dashboard-title',
                        popover: {
                            title: 'Bem-vindo ao Dashboard',
                            description: 'Aqui você acompanha a saúde financeira e o crescimento do seu negócio em tempo real.',
                            side: "bottom",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-daily-summary-section',
                        popover: {
                            title: 'Resumo Diário',
                            description: 'Veja as médias diárias de receitas, despesas, horas trabalhadas e atendimentos.',
                            side: "bottom",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-financial-section',
                        popover: {
                            title: 'Seção Financeiro',
                            description: 'Nesta seção você monitora suas receitas, despesas e projeções.',
                            side: "bottom",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-total-received',
                        popover: {
                            title: 'Total Recebido',
                            description: 'Acompanhe quanto você já recebeu no mês e compare com sua meta. A barra de progresso mostra o quanto você está próximo do objetivo.',
                            side: "top",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-projection',
                        popover: {
                            title: 'Projeção Realizada',
                            description: 'Veja a projeção de ganhos baseada nos atendimentos já realizados, independente se foram pagos ou não.',
                            side: "top",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-expenses',
                        popover: {
                            title: 'Despesas',
                            description: 'Controle seus gastos mensais e mantenha-se dentro do orçamento.',
                            side: "top",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-ticket-average',
                        popover: {
                            title: 'Ticket Médio',
                            description: 'Entenda o valor médio que você recebe por atendimento. Este indicador ajuda a precificar seus serviços.',
                            side: "top",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-effective-hourly-rate',
                        popover: {
                            title: 'Valor Hora Efetivo',
                            description: 'Este é um dos indicadores mais importantes: quanto você realmente ganha por hora trabalhada. Calculado com base no total recebido dividido pelas horas efetivamente trabalhadas.',
                            side: "top",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-effective-hourly-rate-realized',
                        popover: {
                            title: 'Valor Hora Realizado',
                            description: 'Este indicador mostra o valor efetivo da sua hora considerando todos os atendimentos já realizados (Projeção Realizada), divididos pelas horas trabalhadas.',
                            side: "top",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-clients-section',
                        popover: {
                            title: 'Clientes & Crescimento',
                            description: 'Aqui você monitora a expansão da sua base de clientes e métricas de crescimento do negócio.',
                            side: "bottom",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-new-contracts',
                        popover: {
                            title: 'Novos Contratos',
                            description: 'Acompanhe quantos novos clientes você conquistou. Monitore também o CAC (Custo de Aquisição) e o LTV (Valor Vitalício) para entender a saúde do seu negócio.',
                            side: "top",
                            align: 'start'
                        }
                    }
                );
                break;


            case 'customers':
                steps.push(
                    {
                        element: '#tour-customers-title',
                        popover: {
                            title: 'Bem-vindo à Gestão de Clientes',
                            description: 'Aqui você centraliza todas as informações dos seus pacientes, contratos, histórico de atendimentos e muito mais.',
                            side: "bottom",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-new-customer-btn',
                        popover: {
                            title: 'Adicionar Novo Cliente',
                            description: 'Clique aqui para cadastrar um novo cliente. Você pode adicionar dados pessoais, contatos de emergência e informações relevantes para o atendimento.',
                            side: "left",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-filters-btn',
                        popover: {
                            title: 'Filtros Avançados',
                            description: 'Use os filtros para encontrar clientes rapidamente por nome, CPF, status, tipo de pagamento, mês de aniversário e muito mais.',
                            side: "bottom",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-columns-btn',
                        popover: {
                            title: 'Personalizar Colunas',
                            description: 'Personalize quais informações aparecem na tabela. Você pode mostrar ou ocultar colunas como CPF, email, telefone, saldo e data de nascimento.',
                            side: "bottom",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-customers-table',
                        popover: {
                            title: 'Tabela de Clientes',
                            description: 'Esta tabela lista todos os seus clientes. Você pode ordenar por qualquer coluna e usar a busca para filtrar rapidamente.',
                            side: "top",
                            align: 'start',
                            onNextClick: () => {
                                console.log('[Tour] Step 5: Adding fake customer');
                                if (window.$customersPage) {
                                    window.$customersPage.addFakeCustomerForTour();
                                    setTimeout(() => {
                                        this.driverObj.moveNext();
                                    }, 300);
                                } else {
                                    console.warn('[Tour] CustomersPage not found');
                                    this.driverObj.moveNext();
                                }
                            }
                        }
                    },
                    {
                        element: '#tour-expand-customer',
                        popover: {
                            title: 'Expandir Detalhes do Cliente',
                            description: 'Clique na seta para expandir e ver todos os detalhes do cliente, incluindo histórico de atendimentos, contratos e configurações.',
                            side: "left",
                            align: 'center',
                            onNextClick: () => {
                                console.log('[Tour] Step 6: Expanding fake customer');
                                if (window.$customersPage) {
                                    window.$customersPage.expandFakeCustomerForTour();
                                    setTimeout(() => {
                                        this.driverObj.moveNext();
                                    }, 500);
                                } else {
                                    this.driverObj.moveNext();
                                }
                            }
                        }
                    },
                    {
                        element: '#tour-customer-info-card',
                        popover: {
                            title: 'Informações do Cliente',
                            description: 'Aqui você encontra os dados pessoais do cliente: CPF, RG, telefone, email e data de nascimento. Os ícones de WhatsApp e email são clicáveis para contato direto.',
                            side: "right",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-customer-performance-card',
                        popover: {
                            title: 'Desempenho do Cliente',
                            description: 'Este gráfico mostra o histórico de assiduidade do cliente: quantas sessões ele compareceu, faltou ou remarcou. Útil para identificar padrões de comportamento.',
                            side: "left",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-customer-balance-card',
                        popover: {
                            title: 'Saldo do Cliente',
                            description: 'O saldo mostra quanto o cliente deve (negativo), está em dia (zero) ou tem crédito (positivo). A cor do card muda conforme o status financeiro.',
                            side: "left",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-customer-notifications-card',
                        popover: {
                            title: 'Configurações de Notificações (Premium)',
                            description: 'Configure notificações automáticas para este cliente via App Mobile ou WhatsApp. Você pode ativar lembretes de agendamento e cobranças de pagamento individualmente.',
                            side: "top",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-customer-contracts-card',
                        popover: {
                            title: 'Contratos do Cliente',
                            description: 'Visualize todos os contratos do cliente: serviço contratado, frequência, valores, status e próxima data de pagamento. Você pode gerar, assinar e gerenciar contratos diretamente aqui.',
                            side: "top",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-customer-actions',
                        popover: {
                            title: 'Ações Rápidas',
                            description: 'Use estes ícones para acessar rapidamente: contatos de emergência, lista de atendimentos, lista de pagamentos, editar dados ou deletar o cliente.',
                            side: "left",
                            align: 'center'
                        }
                    },
                    {
                        popover: {
                            title: 'Tour Concluído!',
                            description: 'Pronto! Agora você conhece todas as funcionalidades da gestão de clientes. Explore à vontade e organize seus pacientes de forma eficiente.',
                            onNextClick: () => {
                                console.log('[Tour] Step 13: Removing fake customer');
                                if (window.$customersPage) {
                                    window.$customersPage.removeFakeCustomerForTour();
                                }
                                this.driverObj.destroy();
                            }
                        }
                    }
                );
                break;

            case 'notifications':
                steps.push(
                    {
                        element: '#tour-notifications-title',
                        popover: {
                            title: 'Bem-vindo à Central de Notificações',
                            description: 'Aqui você pode enviar mensagens manuais para seus clientes e configurar lembretes automáticos para reduzir faltas e atrasos nos pagamentos.',
                            side: "bottom",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-tabs',
                        popover: {
                            title: 'Abas: Manual vs Automático',
                            description: 'A aba "Enviar Notificação" permite envios manuais pontuais. Já a aba "Configurações" (Premium) automatiza lembretes de agendamento e pagamento.',
                            side: "bottom",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-recipients-card',
                        popover: {
                            title: 'Seleção de Destinatários',
                            description: 'Selecione quem receberá a notificação. Você pode buscar por nome ou usar "Selecionar Todos" para enviar para toda sua base de clientes.',
                            side: "right",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-channel-selection',
                        popover: {
                            title: 'Canais de Envio',
                            description: 'Escolha onde seus clientes receberão a mensagem: apenas no App Mobile, apenas no WhatsApp, ou em ambos os canais simultaneamente.',
                            side: "top",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-variables-alert',
                        popover: {
                            title: 'Variáveis Personalizáveis',
                            description: 'Use variáveis como {{name}}, {{email}} e {{phone}} para personalizar suas mensagens. Cada cliente receberá uma mensagem com seus dados específicos.',
                            side: "bottom",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-notification-form',
                        popover: {
                            title: 'Formulário de Notificação',
                            description: 'Preencha o título e a mensagem da notificação. Você também pode definir para qual tela do app o cliente será direcionado ao clicar.',
                            side: "left",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-preview-section',
                        popover: {
                            title: 'Pré-visualização em Tempo Real',
                            description: 'Veja em tempo real como sua notificação aparecerá no celular do cliente. A pré-visualização muda conforme você digita e seleciona o canal.',
                            side: "left",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-send-button',
                        popover: {
                            title: 'Botão Enviar',
                            description: 'Quando estiver satisfeito com a mensagem e tiver selecionado os destinatários, clique aqui para enviar a notificação.',
                            side: "top",
                            align: 'end'
                        }
                    },
                    {
                        element: '#tour-settings-tab',
                        popover: {
                            title: 'Aba Configurações (Premium)',
                            description: 'Agora vamos explorar as configurações automáticas. Vamos ver como automatizar lembretes para seus clientes.',
                            side: "bottom",
                            align: 'start',
                            onNextClick: () => {
                                console.log('[Tour] Step 9: Switching to settings tab');
                                if (window.$notificationsPage) {
                                    window.$notificationsPage.tab = 1;
                                    setTimeout(() => {
                                        this.driverObj.moveNext();
                                    }, 400);
                                } else {
                                    console.warn('[Tour] NotificationsPage not found');
                                    this.driverObj.moveNext();
                                }
                            }
                        }
                    },
                    {
                        element: '#tour-global-controls',
                        popover: {
                            title: 'Controles Globais',
                            description: 'Ative ou desative notificações automáticas globalmente para App e WhatsApp. Útil para pausar temporariamente sem perder suas configurações.',
                            side: "bottom",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-templates-section',
                        popover: {
                            title: 'Templates Automáticos',
                            description: 'Configure mensagens automáticas para lembretes de agendamento (24h e 1h antes) e cobranças de pagamento. Reduza no-shows e inadimplência sem esforço manual! Explore as configurações e personalize suas mensagens.',
                            align: 'start'
                        }
                    }
                );
                break;

            case 'sessions':
                steps.push(
                    {
                        element: '#tour-sessions-title',
                        popover: {
                            title: 'Central de Atendimentos',
                            description: 'Bem-vindo à sua Central de Atendimentos! Aqui você visualiza, agenda e gerencia todas as suas sessões em um único lugar.',
                            side: "bottom",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-add-session-btn',
                        popover: {
                            title: 'Novo Agendamento',
                            description: 'Precisa marcar um novo horário? Clique aqui para abrir o formulário de agendamento rápido.',
                            side: "left",
                            align: 'center'
                        }
                    },
                    {
                        element: '#tour-filters-btn',
                        popover: {
                            title: 'Filtros Inteligentes',
                            description: 'Encontre exatamente o que precisa. Clique aqui para buscar por período, cliente específico ou status do atendimento.',
                            side: "right",
                            align: 'start',
                            onNextClick: () => {
                                console.log('[Tour] Step 3: Expanding filters');
                                if (window.$sessionsPage) {
                                    window.$sessionsPage.show_filter = true;
                                    setTimeout(() => {
                                        this.driverObj.moveNext();
                                    }, 300);
                                } else {
                                    this.driverObj.moveNext();
                                }
                            }
                        }
                    },
                    {
                        element: '#tour-filters-section',
                        popover: {
                            title: 'Critérios de Busca',
                            description: 'Refine sua busca detalhadamente. Você pode ver, por exemplo, quanto faturou em determinado período ou quais clientes faltaram.',
                            side: "top",
                            align: 'center',
                            onNextClick: () => {
                                console.log('[Tour] Step 4: Collapsing filters and adding fake sessions');
                                if (window.$sessionsPage) {
                                    window.$sessionsPage.show_filter = false;
                                    window.$sessionsPage.addFakeSessionsForTour();
                                    setTimeout(() => {
                                        this.driverObj.moveNext();
                                    }, 300);
                                } else {
                                    this.driverObj.moveNext();
                                }
                            }
                        }
                    },
                    {
                        element: '#tour-sessions-table',
                        popover: {
                            title: 'Lista de Atendimentos',
                            description: 'Aqui está o histórico completo. A tabela organiza os atendimentos por data, mostrando cliente, tipo de serviço e valores.',
                            side: "top",
                            align: 'center'
                        }
                    },
                    {
                        element: '#tour-session-status',
                        popover: {
                            title: 'Status Visual',
                            description: 'Entenda rapidamente o estado de cada sessão pelos ícones:<br>📅 Agendada<br>✅ Finalizada<br>🔄 Reagendada',
                            side: "left",
                            align: 'center'
                        }
                    },
                    {
                        element: '#tour-session-actions',
                        popover: {
                            title: 'Ações Rápidas',
                            description: 'Gerencie cada sessão individualmente. Visualize detalhes, edite informações ou exclua agendamentos incorretos.',
                            side: "left",
                            align: 'center',
                            onNextClick: () => {
                                console.log('[Tour] Step 7: Removing fake sessions');
                                if (window.$sessionsPage) {
                                    window.$sessionsPage.removeFakeSessionsForTour();
                                }
                                this.driverObj.destroy();
                            }
                        }
                    }
                );
                break;

            case 'vouchers':
                steps.push(
                    {
                        element: '#tour-vouchers-title',
                        popover: {
                            title: 'Central de Pagamentos',
                            description: 'Bem-vindo à Gestão de Pagamentos. Aqui você visualiza todos os recebimentos registrados.',
                            side: "bottom",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-export-btn',
                        popover: {
                            title: 'Exportação em CSV',
                            description: 'Precisa dos dados para contabilidade? Exporte tudo para CSV instantaneamente clicando aqui.',
                            side: "left",
                            align: 'center'
                        }
                    },
                    {
                        element: '#tour-filters-btn',
                        popover: {
                            title: 'Filtros de Busca',
                            description: 'Encontre pagamentos de meses anteriores ou busque por clientes específicos aqui.',
                            side: "right",
                            align: 'center',
                            onNextClick: () => {
                                console.log('[Tour] Step 3: Expanding filters');
                                if (window.$vouchersPage) {
                                    window.$vouchersPage.show_filter = true;
                                    setTimeout(() => {
                                        this.driverObj.moveNext();
                                    }, 300);
                                } else {
                                    this.driverObj.moveNext();
                                }
                            }
                        }
                    },
                    {
                        element: '#tour-vouchers-table',
                        popover: {
                            title: 'Lista de Recebimentos',
                            description: 'Esta é sua lista de recebimentos. Veja detalhes como quem pagou, a data e o valor.',
                            side: "top",
                            align: 'center',
                            onNextClick: () => {
                                console.log('[Tour] Step 4: Finishing tour and cleanup');
                                if (window.$vouchersPage) {
                                    window.$vouchersPage.show_filter = false;
                                    window.$vouchersPage.removeFakeVouchersForTour();
                                }
                                this.driverObj.destroy();
                            },
                            onPrevClick: () => {
                                // If going back from table, we likely want to ensure filters are open again? 
                                // Or maybe just standard behavior. 
                                // Let's simplify and just allow standard prev behavior, 
                                // but we need to ensure fake data is there if we arrive here.
                                // Actually, standard prev is fine.
                                this.driverObj.movePrev();
                            }
                        },
                        onHighlightStarted: () => {
                            // Inject fake data when table step starts
                            console.log('[Tour] Step 4 Highlight: Injecting fake vouchers');
                            if (window.$vouchersPage) {
                                window.$vouchersPage.addFakeVouchersForTour();
                                // Also collapse filters for better view of table
                                window.$vouchersPage.show_filter = false;
                            }
                        }
                    }
                );
                break;
            case 'taxes':
                steps.push(
                    {
                        element: '#tour-taxes-title',
                        popover: {
                            title: 'Despesas Programadas',
                            description: 'Bem-vindo às Despesas Programadas. Aqui você organiza suas contas a pagar e previsões financeiras.',
                            side: "bottom",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-manage-categories-btn',
                        popover: {
                            title: 'Gerenciar Categorias',
                            description: 'Antes de começar, organize suas despesas em categorias personalizadas (ex: Aluguel, Impostos, Marketing).',
                            side: "left",
                            align: 'center'
                        }
                    },
                    {
                        element: '#tour-add-tax-btn',
                        popover: {
                            title: 'Nova Despesa',
                            description: 'Clique aqui para programar uma nova conta. Você pode definir a data de vencimento e o valor previsto.',
                            side: "left",
                            align: 'center'
                        }
                    },
                    {
                        element: '#tour-taxes-table',
                        popover: {
                            title: 'Tabela de Despesas',
                            description: 'Aqui você visualiza todas as suas obrigações. Acompanhe vencimentos, valores e categorias.',
                            side: "top",
                            align: 'center',
                            onNextClick: () => {
                                // Just ensuring we move to the next step, which targets the first row
                                this.driverObj.moveNext();
                            }
                        },
                        onHighlightStarted: () => {
                            // Inject fake data when table step starts
                            console.log('[Tour] Step 4 Highlight: Injecting fake taxes');
                            if (window.$taxesPage) {
                                window.$taxesPage.addFakeTaxesForTour();
                            }
                        }
                    },
                    {
                        element: '.v-data-table__wrapper tbody tr:first-child',
                        popover: {
                            title: 'Ações Rápidas',
                            description: 'Registre pagamentos, edite valores ou exclua lançamentos diretamente por aqui.',
                            side: "top",
                            align: 'center',
                            onNextClick: () => {
                                console.log('[Tour] Step 5: Finishing Taxes tour and cleanup');
                                if (window.$taxesPage) {
                                    window.$taxesPage.removeFakeTaxesForTour();
                                }
                                this.driverObj.destroy();
                            }
                        }
                    }
                );
                break;
            case 'contract-templates':
                steps.push(
                    {
                        element: '#tour-contract-templates-title',
                        popover: {
                            title: 'Gerencie seus Contratos',
                            description: 'Aqui você define os termos e condições legais para cada tipo de serviço oferecido.',
                            side: "bottom",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-contract-templates-search',
                        popover: {
                            title: 'Busca de Serviços',
                            description: 'Tem muitos serviços? Use a busca para encontrar rapidamente aquele que você quer configurar.',
                            side: "left",
                            align: 'center'
                        }
                    },
                    {
                        element: '#tour-contract-templates-table',
                        popover: {
                            title: 'Status dos Contratos',
                            description: 'Veja facilmente quais serviços já possuem contrato configurado (Verde) e quais ainda precisam de atenção (Amarelo).',
                            side: "top",
                            align: 'center',
                            onNextClick: () => {
                                // Just ensuring we move to the next step, which targets the real/fake row
                                this.driverObj.moveNext();
                            }
                        },
                        onHighlightStarted: () => {
                            // Inject fake data
                            console.log('[Tour] Step 3 Highlight: Injecting fake templates');
                            if (window.$contractTemplatesPage) {
                                window.$contractTemplatesPage.addFakeTemplatesForTour();
                            }
                        }
                    },
                    {
                        element: '.v-data-table__wrapper tbody tr:first-child .v-btn',
                        popover: {
                            title: 'Editar ou Criar',
                            description: 'Clique em "Editar" para ajustar um contrato existente ou "Criar" para definir um novo do zero.',
                            side: "left",
                            align: 'center',
                            onNextClick: () => {
                                console.log('[Tour] Step 4: Finishing Contract Templates tour and cleanup');
                                if (window.$contractTemplatesPage) {
                                    window.$contractTemplatesPage.removeFakeTemplatesForTour();
                                }
                                this.driverObj.destroy();
                            }
                        }
                    }
                );
                break;

            case 'reschedule-requests':
                steps.push(
                    {
                        element: '#tour-reschedule-title',
                        popover: {
                            title: 'Bem-vindo à Gestão de Reagendamentos',
                            description: 'Aqui você gerencia todas as solicitações de remarcação enviadas pelos seus clientes através do App Mobile.',
                            side: "bottom",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-status-chip',
                        popover: {
                            title: 'Indicador de Status',
                            description: 'Este indicador mostra quantas solicitações estão aguardando sua decisão. Fique de olho nele para não deixar clientes esperando!',
                            side: "left",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-tabs',
                        popover: {
                            title: 'Navegação por Abas',
                            description: 'As abas organizam as solicitações por status: Pendentes (precisam de ação), Aceitas (histórico de aprovações), Recusadas (negadas) e Contrapropostas (negociações em andamento).',
                            side: "bottom",
                            align: 'start',
                            onNextClick: () => {
                                console.log('[Tour] Step 3: Adding fake requests');
                                if (window.$rescheduleRequestsPage) {
                                    window.$rescheduleRequestsPage.addFakeRequestsForTour();
                                    setTimeout(() => {
                                        this.driverObj.moveNext();
                                    }, 300);
                                } else {
                                    console.warn('[Tour] RescheduleRequestsPage not found');
                                    this.driverObj.moveNext();
                                }
                            }
                        }
                    },
                    {
                        element: '#tour-pending-request',
                        popover: {
                            title: 'Solicitação Pendente',
                            description: 'Aqui está uma solicitação de reagendamento. Veja as informações principais: cliente, serviço, horário atual e horário solicitado. Vamos expandir para ver mais detalhes.',
                            side: "right",
                            align: 'start',
                            onNextClick: () => {
                                console.log('[Tour] Step 4: Expanding first pending request');
                                if (window.$rescheduleRequestsPage) {
                                    window.$rescheduleRequestsPage.expandFirstPendingForTour();
                                    setTimeout(() => {
                                        this.driverObj.moveNext();
                                    }, 500);
                                } else {
                                    this.driverObj.moveNext();
                                }
                            }
                        }
                    },
                    {
                        element: '#tour-request-reason',
                        popover: {
                            title: 'Motivo da Solicitação',
                            description: 'O cliente pode explicar o motivo da remarcação. Isso ajuda você a entender a urgência e tomar a melhor decisão.',
                            side: "top",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-approve-button',
                        popover: {
                            title: 'Ações: Aprovar',
                            description: 'Se o novo horário funciona para você, clique em "Aprovar". O agendamento será automaticamente remarcado na sua agenda.',
                            side: "top",
                            align: 'end'
                        }
                    },
                    {
                        element: '#tour-propose-button',
                        popover: {
                            title: 'Ações: Propor Novo Horário',
                            description: 'Não pode no horário solicitado? Não precisa recusar! Clique aqui para propor um horário alternativo. O cliente receberá a proposta no app e poderá aceitar ou recusar.',
                            side: "top",
                            align: 'center'
                        }
                    },
                    {
                        element: '#tour-reject-button',
                        popover: {
                            title: 'Ações: Rejeitar',
                            description: 'Se não for possível reagendar, você pode rejeitar a solicitação. O cliente será notificado e o horário original será mantido.',
                            side: "top",
                            align: 'start'
                        }
                    },
                    {
                        element: '#tour-accepted-tab',
                        popover: {
                            title: 'Aba Aceitas',
                            description: 'Vamos ver o histórico de solicitações aceitas. Aqui você consulta todos os reagendamentos que foram aprovados.',
                            side: "bottom",
                            align: 'start',
                            onNextClick: () => {
                                console.log('[Tour] Step 9: Switching to accepted tab');
                                if (window.$rescheduleRequestsPage) {
                                    window.$rescheduleRequestsPage.currentTab = 1;
                                    setTimeout(() => {
                                        this.driverObj.moveNext();
                                    }, 400);
                                } else {
                                    this.driverObj.moveNext();
                                }
                            }
                        }
                    },
                    {
                        element: '#tour-rejected-tab',
                        popover: {
                            title: 'Aba Recusadas',
                            description: 'Esta aba registra as solicitações que foram recusadas. Útil para consultar o histórico e entender padrões.',
                            side: "bottom",
                            align: 'start',
                            onNextClick: () => {
                                console.log('[Tour] Step 10: Switching to rejected tab');
                                if (window.$rescheduleRequestsPage) {
                                    window.$rescheduleRequestsPage.currentTab = 2;
                                    setTimeout(() => {
                                        this.driverObj.moveNext();
                                    }, 400);
                                } else {
                                    this.driverObj.moveNext();
                                }
                            }
                        }
                    },
                    {
                        element: '#tour-counterproposals-tab',
                        popover: {
                            title: 'Aba Contrapropostas',
                            description: 'Aqui ficam as contrapropostas que você enviou. Você pode acompanhar se o cliente aceitou, recusou ou ainda está analisando.',
                            side: "bottom",
                            align: 'start',
                            onNextClick: () => {
                                console.log('[Tour] Step 11: Switching to counterproposals tab');
                                if (window.$rescheduleRequestsPage) {
                                    window.$rescheduleRequestsPage.currentTab = 3;
                                    setTimeout(() => {
                                        this.driverObj.moveNext();
                                    }, 400);
                                } else {
                                    this.driverObj.moveNext();
                                }
                            }
                        }
                    },
                    {
                        popover: {
                            title: 'Tour Concluído!',
                            description: 'Pronto! Agora você sabe como gerenciar solicitações de reagendamento. Use as contrapropostas para manter seus clientes satisfeitos e sua agenda organizada!',
                            onNextClick: () => {
                                console.log('[Tour] Step 12: Removing fake requests');
                                if (window.$rescheduleRequestsPage) {
                                    window.$rescheduleRequestsPage.removeFakeRequestsForTour();
                                    window.$rescheduleRequestsPage.currentTab = 0;
                                }
                                this.driverObj.destroy();
                            }
                        }
                    }
                );
                break;

            case 'medical_records_feature':
                steps.push(
                    {
                        popover: {
                            title: '📝 Novo Prontuário Digital',
                            description: 'O módulo de prontuários foi totalmente reformulado! Vamos fazer um tour guiado para conhecer as novidades.',
                            align: 'center',
                            onNextClick: () => {
                                if (this.router && this.router.currentRoute.name !== 'schedule') {
                                    this.router.push({ name: 'schedule' }).catch(()=>{});
                                }
                                setTimeout(() => {
                                    if (window.$schedulePage) {
                                        window.$schedulePage.addFakeSessionForTour();
                                    }
                                    this.driverObj.moveNext();
                                }, 800);
                            }
                        }
                    },
                    {
                        element: '#tour-schedule-confirm-btn',
                        popover: {
                            title: 'Acesso pelo Agendamento',
                            description: 'Ao confirmar ou editar um atendimento na sua agenda, você tem acesso rápido ao prontuário.',
                            side: "top",
                            align: 'center',
                            onNextClick: () => {
                                if (window.$customerInfo) {
                                    window.$customerInfo.openConfirmSession();
                                }
                                setTimeout(() => {
                                    this.driverObj.moveNext();
                                }, 500);
                            }
                        }
                    },
                    {
                        element: '#tour-dialog-medical-record-btn',
                        popover: {
                            title: 'Prontuário na Confirmação',
                            description: 'Você pode acessar o conteudo do prontuário clicando nesse botao antes ou depois de confirmar o atendimento.',
                            side: "bottom",
                            align: 'center',
                            onNextClick: () => {
                                if (window.$dialogConfirmSession) {
                                    window.$dialogConfirmSession.show_medical_record = true;
                                }
                                setTimeout(() => {
                                    this.driverObj.moveNext();
                                }, 800);
                            }
                        }
                    },
                    {
                        element: '#tour-medical-record-editor',
                        popover: {
                            title: 'Editor de Textos Rico',
                            description: 'Você pode personalizar o conteudo do prontuário como quiser utilizando o editor de textos, adicionando formatações, listas e links.',
                            side: "top",
                            align: 'center'
                        }
                    },
                    {
                        element: '#tour-medical-record-attachments',
                        popover: {
                            title: 'Central de Anexos',
                            description: 'Agora você pode anexar não apenas PDFs, mas também imagens, áudios e vídeos diretamente no prontuário do atendimento!',
                            side: "top",
                            align: 'center',
                            onNextClick: () => {
                                if (window.$dialogMedicalRecord) {
                                    window.$dialogMedicalRecord.close();
                                }
                                if (window.$dialogConfirmSession) {
                                    window.$dialogConfirmSession.close();
                                }
                                setTimeout(() => {
                                    this.driverObj.moveNext();
                                }, 500);
                            }
                        }
                    },
                    {
                        element: '#tour-schedule-medical-record-btn',
                        popover: {
                            title: 'Acesso Rápido',
                            description: 'Você também pode acessar o prontuário diretamente do perfil do cliente clicando aqui.',
                            side: "top",
                            align: 'center'
                        }
                    },
                    {
                        element: '#tour-schedule-export-btn',
                        popover: {
                            title: 'Exportação Unificada',
                            description: 'Também adicionamos um botão para facilitar a exportação de todos os prontuários do cliente em um único arquivo PDF.',
                            side: "top",
                            align: 'center',
                            onNextClick: () => {
                                if (window.$schedulePage) {
                                    window.$schedulePage.removeFakeSessionForTour();
                                }
                                if (this.router && this.router.currentRoute.name !== 'sessions') {
                                    this.router.push({ name: 'sessions' }).catch(()=>{});
                                }
                                setTimeout(() => {
                                    this.driverObj.moveNext();
                                }, 800);
                            }
                        }
                    },
                    {
                        element: '#tour-export-medical-records-btn',
                        popover: {
                            title: 'Exportação na Lista',
                            description: 'Na listagem geral de atendimentos, você também encontra o atalho para exportar os prontuários de qualquer cliente.',
                            side: "bottom",
                            align: 'start',
                            onNextClick: () => {
                                if (this.router && this.router.currentRoute.name !== 'customers') {
                                    this.router.push({ name: 'customers' }).catch(()=>{});
                                }
                                setTimeout(() => {
                                    if (window.$customersPage) {
                                        window.$customersPage.addFakeCustomerForTour();
                                    }
                                    this.driverObj.moveNext();
                                }, 800);
                            }
                        }
                    },
                    {
                        element: '#tour-customer-list-sessions',
                        popover: {
                            title: 'Perfil do Cliente',
                            description: 'Acesse a lista de atendimentos do cliente para conferir o histórico completo.',
                            side: "top",
                            align: 'center',
                            onNextClick: () => {
                                if (window.$customersPage) {
                                    const fakeCustomer = window.$customersPage.customers_list.find(c => c.id === 'tour-fake-customer');
                                    if (fakeCustomer) {
                                        window.$customersPage.showSessions(fakeCustomer);
                                    }
                                }
                                setTimeout(() => {
                                    this.driverObj.moveNext();
                                }, 800);
                            }
                        }
                    },
                    {
                        element: '#tour-list-sessions-medical-record',
                        popover: {
                            title: 'Prontuário no Histórico',
                            description: 'No histórico de atendimentos, você pode consultar ou editar os prontuários de cada sessão clicando neste botão.',
                            side: "left",
                            align: 'center'
                        }
                    },
                    {
                        element: '#tour-list-sessions-export',
                        popover: {
                            title: 'Pronto para uso!',
                            description: 'E você também pode exportar todos os prontuários diretamente da lista de histórico. Aproveite todas essas novidades para melhorar o seu atendimento!',
                            side: "top",
                            align: 'center',
                            onNextClick: () => {
                                if (window.$dialogListSessions) {
                                    window.$dialogListSessions.close();
                                }
                                if (window.$customersPage) {
                                    window.$customersPage.removeFakeCustomerForTour();
                                }
                                this.driverObj.destroy();
                            }
                        }
                    }
                );
                break;

            default:
                steps.push(
                    {
                        element: '#tour-sidemenu-schedule',
                        popover: {
                            title: 'Agenda',
                            description: 'Visualize e gerencie seus agendamentos aqui.',
                            side: "right",
                            align: 'start'
                        }
                    },
                    fabStep
                );
                break;
        }

        return steps;
    }
}

export default new TourService();
